import apiBase from "../../api/axios";

export const getFrasesConfirmacionService = async (page = 1, search = "", talento = "", pregunta = "") => {
  let url = `v1/talentos-global/frases-confirmacion/?page=${page}`;
  if (search) {
    url += `&search=${encodeURIComponent(search)}`;
  }
  if (talento) {
    url += `&talento=${talento}`;
  }
  if (pregunta) {
    url += `&pregunta=${pregunta}`;
  }
  const response = await apiBase.get(url);
  return response.data;
};

export const createMultipleFrasesConfirmacionService = async (payload) => {
  const response = await apiBase.post("v1/talentos-global/frases-confirmacion/crear-multiples/", payload);
  return response.data;
};

export const getFraseConfirmacionByIdService = async (id) => {
  const response = await apiBase.get(`v1/talentos-global/frases-confirmacion/${id}/`);
  return response.data;
};

export const updateFraseConfirmacionService = async (id, payload) => {
  const response = await apiBase.put(`v1/talentos-global/frases-confirmacion/${id}/`, payload);
  return response.data;
};

export const toggleFraseConfirmacionActiveService = async (id) => {
  const response = await apiBase.patch(`v1/talentos-global/frases-confirmacion/${id}/toggle-status/`);
  return response.data;
};
